const _messages = {
    vnRequired: 'Virtual number is required!',
    messsgeRequired: 'Message is required'
}
export default _messages;